// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfv_a"};